const clamp = value => Math.max(0, Math.min(1, value));

// Original, lightweight 2D treatment inspired by the supplied visual reference.
export const paintDotGrid = (ctx, width, height, point) => {
  ctx.clearRect(0, 0, width, height);
  const wash = ctx.createLinearGradient(0, height, width, 0);
  wash.addColorStop(0, 'rgba(118,174,159,0)');
  wash.addColorStop(.4, 'rgba(118,174,159,0.018)');
  wash.addColorStop(.68, 'rgba(133,154,197,0.055)');
  wash.addColorStop(1, 'rgba(133,154,197,0)');
  ctx.fillStyle = wash;
  ctx.fillRect(0, 0, width, height);

  const radius = Math.min(430, Math.max(260, width * .28));
  const glow = ctx.createRadialGradient(point.x, point.y, 0, point.x, point.y, radius);
  glow.addColorStop(0, `rgba(119,176,197,${.022 + point.power * .065})`);
  glow.addColorStop(.45, `rgba(119,158,182,${.014 + point.power * .035})`);
  glow.addColorStop(1, 'rgba(119,158,182,0)');
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, width, height);

  for (let y = 11; y < height; y += 22) {
    for (let x = 11; x < width; x += 22) {
      const edge = clamp(1 - Math.pow(Math.hypot((x - width / 2) / (width * .56), (y - height / 2) / (height * .75)), 2));
      const nearby = Math.pow(clamp(1 - Math.hypot(x - point.x, y - point.y) / 300), 2) * point.power;
      ctx.fillStyle = `rgba(185,207,207,${edge * (.10 + nearby * .38)})`;
      ctx.beginPath();
      ctx.arc(x, y, .7 + nearby * .38, 0, Math.PI * 2);
      ctx.fill();
    }
  }
  const vignette = ctx.createRadialGradient(width / 2, height / 2, Math.min(width, height) * .18, width / 2, height / 2, Math.max(width, height) * .64);
  vignette.addColorStop(0, 'rgba(16,17,18,0)');
  vignette.addColorStop(1, 'rgba(16,17,18,.93)');
  ctx.fillStyle = vignette;
  ctx.fillRect(0, 0, width, height);
};